// extracted by mini-css-extract-plugin
export default {"heading":"AvmModuleHeading_heading__kmB4t","forceNoWrap":"AvmModuleHeading_forceNoWrap__i2YKy"};